import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Link} from '@github-ui/react-router'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Transitional: repository-milestone still has Relay deps for mutation fallback paths; will be cleaned up when mutations are fully migrated.
import {RepositoryMilestonesInternal} from '@github-ui/repository-milestone/RepositoryMilestones'
import {Button} from '@primer/react'

import {issuesLayoutRoute} from './issues-layout-route'
import {milestoneIndexRoute} from './milestone-index-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function MilestoneIndex() {
  const {owner, repo} = useRouteParams(milestoneIndexRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const payload = useRouteQuery(milestoneIndexRoute, 'mainQuery')

  const renderSidebarFn = useRenderSidebar(owner, repo, layoutPayload)
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  // FORBIDDEN/SAML reloads the page; other errors throw to the boundary.
  const data = handleRepositoryDataError(payload.data)
  if (!data?.repository) {
    return null
  }

  const repository = data.repository
  const headerActions =
    sidebarLayoutEnabled && repository.viewerCanCreateMilestones ? (
      <Button as={Link} to={`/${repository.nameWithOwner}/milestones/new`} variant="primary">
        New milestone
      </Button>
    ) : undefined

  return (
    <BaseAnalyticsWrapper category="Repository Milestone Index" appName="issues">
      <RepoIssuesPageLayout
        dialogTitle="Milestones"
        title={sidebarLayoutEnabled ? 'Milestones' : undefined}
        actions={headerActions}
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebarExpanded}
      >
        <RepositoryMilestonesInternal repository={repository} queryKey={payload.queryKey} />
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
